// Central scroll ownership coordinator.
// Ensures only one system (Hero wheel controller OR Navbar anchor tween)
// controls scroll at any given moment.

let anchorNavigating = false;
let currentTweenId = 0;

export const isAnchorNavigating = () => anchorNavigating;

export const setAnchorNavigating = (v: boolean) => {
  anchorNavigating = v;
};

// Fire when navbar is about to start an anchor tween.
// Hero listens and hard-releases its wheel lock + cancels pending state work.
export const releaseHero = () => {
  window.dispatchEvent(new CustomEvent('hero:release'));
};

// Cancel any in-flight tween by bumping the id.
export const nextTweenId = () => ++currentTweenId;
export const getTweenId = () => currentTweenId;

// Native smooth scroll with completion detection. Native scroll is compositor-driven
// and does not compete with React work each frame like a custom RAF tween.
export function tweenScrollTo(targetY: number, _duration = 720): Promise<void> {
  return new Promise((resolve) => {
    const startY = window.scrollY;
    const diff = targetY - startY;
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const myId = nextTweenId();
    if (reduce || Math.abs(diff) < 4) {
      window.scrollTo(0, targetY);
      resolve();
      return;
    }
    try {
      window.scrollTo({ top: targetY, left: 0, behavior: 'smooth' });
    } catch {
      window.scrollTo(0, targetY);
      resolve();
      return;
    }
    // Detect when native smooth scroll settles by watching scrollY stabilise.
    let lastY = window.scrollY;
    let stableFrames = 0;
    let raf = 0;
    const check = () => {
      if (myId !== getTweenId()) { resolve(); return; }
      const y = window.scrollY;
      const atTarget = Math.abs(y - targetY) < 1.5;
      if (y === lastY) stableFrames++; else stableFrames = 0;
      lastY = y;
      if (atTarget && stableFrames >= 3) { resolve(); return; }
      if (stableFrames >= 20) { resolve(); return; } // safety
      raf = requestAnimationFrame(check);
    };
    raf = requestAnimationFrame(check);
    // additional hard safety timeout
    window.setTimeout(() => { if (raf) cancelAnimationFrame(raf); resolve(); }, 2000);
  });
}